import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { LocalizableComponent } from '../../../../localization/localizable.component';

@Component({
  selector: 'broker-go-to-full-application-dialog',
  templateUrl: './go-to-full-application-dialog.component.html',
  styleUrls: ['./go-to-full-application-dialog.component.scss']
})
export class GoToFullApplicationDialogComponent extends LocalizableComponent {
  @Output() submitEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() cancelEvent: EventEmitter<void> = new EventEmitter<void>();

  constructor(@Inject(L10N_LOCALE) locale: L10nLocale) {
    super(locale);
  }
}
